<template>
  <div>
    <div class="recent_user activity_avatar onlinepeeps" v-for="user in users" ref="tooltip">
      <a :href="user.url" :aria-label="tooltiptitle(user)" class="hint--top-left">
        <img :src="user.thumb"
             :alt="user.name"
             class="ag"
             height="50"
             width="50"/>
      </a>
      <div v-if="user.last_seen_one_hour_ago"
           id="indicatoronline"
           class="bg-green pos-absolute bottom-0 right-0 rounded-50">
      </div>
    </div>
  </div>
</template>

<script>
  import docendo from '../docendo'
  import moment from 'moment'

  export default {
    name: 'recent-users',
    data: function () {
      return {
        users: []
      }
    },
    props: ['school'],
    methods: {
      tooltiptitle (user) {
        return user.name + ' ' + this.timeFromNow(user.last_seen)
      },
      timeFromNow (m) { // TODO copied from filters.js
        if (m !== null) {
          return this.$i18n.t('vue.recent_users.last_seen') + ' ' + moment(m).fromNow()
        } else {
          return this.$i18n.t('vue.recent_users.never_logged_in')
        }
      },
      update () {
        docendo.getRecentUsers(this.school, 25, this.updated)
      },
      updated (data) {
        this.users = data
      },
      startRefreshing () {
        this.timer = setInterval(this.update, 60000)
      },
      stopRefreshing () {
        clearInterval(this.timer)
      }
    },
    mounted () {
      this.update()
      this.startRefreshing()
    },
    beforeDestroy () {
      this.stopRefreshing()
    },
    created () {
      this.$on('docendo_state', function (data) {
        if (data === 'connected') {
          this.startRefreshing()
        } else if (data === 'disconnected') {
          this.stopRefreshing()
        }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// RecentUsers.vue?5aea0ba0